export default __webpack_public_path__ + "static/media/patrimonio.d3564491.svg";